import styled from 'styled-components'

const ScreenReaderOnlyText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  white-space: nowrap;
`

export default ScreenReaderOnlyText
